class hoursView {
  #parentElement = document.querySelector(".forecast-hour-container");
  #data;
  #joinedMarkup = "";
  buttonLeft = document.querySelector(".btn-left-hour");
  buttonRight = document.querySelector(".btn-right-hour");

  render(data) {
    this.#data = data;
    // console.log(this.#data.weatherData.daily.dailyGroup[3].hourly[6]);
    // console.log(this.#data.weatherData.daily.day);
    // console.log(this.#data.day);

    this.#clear();
    this.joinMarkup();
    const markup = this.#joinedMarkup;
    this.#parentElement.insertAdjacentHTML("afterbegin", markup);
  }

  #clear() {
    this.#parentElement.innerHTML = "";
    this.#joinedMarkup = "";
  }

  joinMarkup() {
    for (
      let i = 0;
      i < this.#data.weatherData.daily.dailyGroup[this.#data.day].hourly.length;
      i++
    ) {
      this.#joinedMarkup = this.#joinedMarkup + this.#generateMarkup(i);
    }
  }

  #generateMarkup(i) {
    return `<div class="forecast-hour-box">
    <p class="forecast-hour-time">${
      this.#data.weatherData.daily.dailyGroup[this.#data.day].hourly[i].time
    }</p>
    <img
      src="${
        this.#data.weatherData.daily.dailyGroup[this.#data.day].hourly[i]
          .weatherIcon
      }"
      alt=""
      class="days-icon icon"
    />
    <div class="temp-hour">
      <span class="temp">${
        this.#data.tempUnit === "celcius"
          ? this.#data.weatherData.daily.dailyGroup[this.#data.day].hourly[i]
              .temp
          : this.#data.weatherData.daily.dailyGroup[this.#data.day].hourly[i]
              .tempF
      }</span><span class="degree-symbol">°</span
      >
    </div>
  </div>`;
  }

  addHandlerButtonRight() {
    this.buttonRight.addEventListener(
      "click",
      function () {
        this.#parentElement.scrollBy({
          top: 0,
          left: +500,
          behavior: "smooth",
        });
        console.log(this.#parentElement);
        console.log("firerighthour");
      }.bind(this)
    );
  }

  addHandlerButtonLeft() {
    this.buttonLeft.addEventListener(
      "click",
      function () {
        this.#parentElement.scrollBy({
          top: 0,
          left: -500,
          behavior: "smooth",
        });
        console.log(this.#parentElement);
        console.log("firelefthour");
      }.bind(this)
    );
  }
}

export default new hoursView();
